import type { UseQueryResult } from "@tanstack/react-query";

import type { AiTrackerReportsSourceAnalysisGraphResponse } from "@similarweb/pro-api-client";

import { apiClient } from "app/modules/api-client";
import { useLLMReportQuery } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMReportQuery";
import type { ILLMWidgetRequestParams } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface ISourceDomainsParams extends ILLMWidgetRequestParams {
    maxDomains: number;
}

export const useSourceDomains = (
    params: ISourceDomainsParams,
    options?: { enabled?: boolean },
): UseQueryResult<AiTrackerReportsSourceAnalysisGraphResponse> =>
    useLLMReportQuery<AiTrackerReportsSourceAnalysisGraphResponse, ISourceDomainsParams>(
        "sourceDomains",
        apiClient.AiTracker.aiTrackerReportsSourceAnalysisReportGraphList,
        params,
        options,
    );
